import { Group, Text } from '@mantine/core';
import AppIcon from '@/components/AppIcon.tsx';
import { TiPin } from 'react-icons/ti';
import React from 'react';
import { usePinnedStep } from '@/hooks/usePinnedStep.ts';
import { AutomationStep, ParentStep } from '@/types/automationSteps.ts';
import { formatStepLabel } from '@/utils/misc.ts';
import { StepRun } from '@/types/stepExecutions.ts';

type props = {
  step: AutomationStep;
  index: number;
  parentSteps: (StepRun | ParentStep)[];
  runId?: string;
  displayLabel?: string;
  displayPath?: string;
  placement?: 'above' | 'inside';
};

const StepCardTopLabel = ({
  step,
  index,
  parentSteps,
  runId,
  displayLabel,
  displayPath,
  placement = 'above',
}: props) => {
  const { isStepPinned } = usePinnedStep(step, runId);
  const label = displayLabel ?? formatStepLabel(step, index, parentSteps);

  return (
    <Group
      mb={4}
      style={
        placement === 'inside'
          ? { width: '100%' }
          : { position: 'absolute', top: -20, width: '100%' }
      }
      gap="2px"
      wrap={'nowrap'}
    >
      <Text
        size="xs"
        c="dimmed"
        truncate={'end'}
        style={{ minWidth: 0 }}
        title={displayPath ?? label}
      >
        {label}
      </Text>
      {isStepPinned && <AppIcon Icon={TiPin} size={14} color="#FF761F" />}
    </Group>
  );
};

export default StepCardTopLabel;
